import { useQuery } from '@tanstack/react-query';

import { standbyCustomerEntriesQuery } from '@/api/standby/standbyCustomerEntriesQuery';
import { useHasSession } from '@/hooks/auth/useHasSession';
import { useCustomerQuery } from '@/hooks/queries/customer/useCustomerQuery';
import { shouldRetryApiFailure } from '@/utils/apiErrors';

import type { UseStandbyCustomerEntriesQueryOptions } from './types';

export const useStandbyCustomerEntriesQuery = (
  options?: UseStandbyCustomerEntriesQueryOptions,
) => {
  const { customerId } = useCustomerQuery();
  const hasSession = useHasSession();

  return useQuery({
    ...standbyCustomerEntriesQuery(customerId),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-id
    // guard — matches useStandbyActiveEntryQuery/useStandbyStylistsQuery.
    enabled: !!customerId && hasSession && (options?.enabled ?? true),
    retry: shouldRetryApiFailure,
    refetchOnWindowFocus: true,
    // Polls only while an offer is live so the countdown pill stays fresh;
    // otherwise the list is refreshed by focus/push only.
    refetchInterval: (query) =>
      query.state.data?.entries.some((entry) => entry.state === 'offer')
        ? 15000
        : false,
  });
};
